// CRA/Vercel uyumlu: import.meta kullanmadan process.env üzerinden oku
const RAW_FROM_CRA = (typeof process !== 'undefined' ? (process as any)?.env?.REACT_APP_API_BASE_URL : undefined) as string | undefined | null;
const RAW_FROM_VITE_NODE = (typeof process !== 'undefined' ? (process as any)?.env?.VITE_API_BASE_URL : undefined) as string | undefined | null;

const pick = (v?: string | null) => (v && v.trim() ? v.trim() : undefined);

// const resolved = pick(RAW_FROM_CRA) || pick(RAW_FROM_VITE_NODE) || 'http://localhost:4000';  //local için 
// const resolved = pick(RAW_FROM_CRA) || pick(RAW_FROM_VITE_NODE) || 'https://megapark.onrender.com/';
// const resolved = pick(RAW_FROM_CRA) || pick(RAW_FROM_VITE_NODE) || 'http://185.111.235.199:4000';
const resolved = pick(RAW_FROM_CRA) || pick(RAW_FROM_VITE_NODE) || 'https://megaparkhastanesi.com';


// Sonda / varsa kaldır
export const API_BASE: string = resolved.replace(/\/+$/, '');
export const toUrl = (u: string) => (/^https?:\/\//i.test(u) ? u : `${API_BASE}${u}`);
